export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10790.16b849d0.jpg";